import React, { Component } from "react";

class Main extends Component {
    render() {
        return (
            <button type="button"
                className={"main__item " + (this.props.isSelected && "main__item--selected")}
                key={this.props.index}
                onClick={()=>{this.props.selectSvg(this.props.svgName)}}
                aria-label={`Select ${this.props.svgName.replace(".svg", "")} icon`}
            >
                <svg className="ikonate" aria-hidden="true">
                    <use xlinkHref={ "./img/ikonate.svg#" + this.props.svgName.replace(".svg", "")}/>
                </svg>
            </button>
        );
    }
}

export default Main;



// WEBPACK FOOTER //
// ./src/components/Svg.js